export const FATAL_ERROR_VOUCHER_CODE = '500';
